import { render, staticRenderFns } from "./BasePromoModule.vue?vue&type=template&id=ed0a6186&scoped=true&"
import script from "./BasePromoModule.vue?vue&type=script&lang=js&"
export * from "./BasePromoModule.vue?vue&type=script&lang=js&"
import style0 from "./BasePromoModule.vue?vue&type=style&index=0&id=ed0a6186&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed0a6186",
  null
  
)

export default component.exports